import React, { useState, useEffect, useMemo } from 'react';

import SearchHeader from './SearchHeader';
import SearchItem from './SearchItem';

import './style.scss';

const SearchResults = ({ data, scrollView }) => {
  const [items, setItems] = useState([]);
  const [currentData, setCurrentData] = useState();

  // Listen to data changes, and either append the results if the current page changes,
  // or replace all results if we are changing the filter values. This will give us
  // "load more" functionality.
  useEffect(() => {
    if (!data || typeof data.results === 'undefined') return;

    const currentPageNumber = data.results.hits.page.pageNumber;
    const dataChanged = JSON.stringify(currentData) !== JSON.stringify(data);

    if (dataChanged) {
      if (items.length === 0 || currentPageNumber === 0) {
        setItems([...data.results.hits.items]);
      } else {
        setItems([...items, ...data.results.hits.items]);
      }

      setCurrentData(data);
    }
  }, [data, currentData]);

  // Listen to the page changes, and reset scroll position if we are at the first page.
  useEffect(() => {
    if (!currentData) {
      return;
    }

    const currentPageNumber = currentData.results.hits.page.pageNumber;
    if (scrollView.current && currentPageNumber === 0) {
      scrollView.current.scrollTop = 0;
    }
  }, [currentData, scrollView]);

  // By default, we assume the initial item is inside our search area.
  let insideArea = 1;

  const itemsFound = useMemo(() => {
    return items.reduce((value, item) => {
      if (item.inside_area === 0) {
        return value;
      }
      return value + 1;
    }, 0);
  }, [items]);

  return (
    <div className="SearchResults">
      {data && <SearchHeader data={data} />}

      {items.map((item) => {
        if (insideArea === 1 && item.inside_area === 0) {
          insideArea = item.inside_area;
          return (
            <span key={item.id}>
              {itemsFound > 0
                && (
                  <div className="SearchResults__outside-search-notify">
                    <a
                      href="https://formulieren.oranjefonds.nl/updates_nldoet_vrijwilligers_nodig_in_mijn_gemeente"
                      rel="noreferrer"
                      target="_blank">
                      Er zijn verder geen zoekresultaten binnen je zoekopdracht. Wil je op de hoogte gehouden worden van nieuwe activiteiten binnen jouw zoekopdracht? Meld je aan voor de servicemail.
                    </a>
                  </div>
                )}
              <h2 className="SearchHeader SearchHeader--outside-search-area">Activiteiten buiten je zoekopdracht</h2>
              <SearchItem item={item} />
            </span>
          );
        }

        insideArea = item.inside_area;
        return (<SearchItem key={item.id} item={item} />);
      })}
    </div>
  );
};

export default SearchResults;
